import {useNavigate} from 'react-router-dom';
import {
  SoopLayer,
  SoopLayerHeader,
  SoopLayerContent,
  SoopSheetTitle,
  SoopButtonCommon,
} from '@soop-ui/soop-ui';
import styles from './IllegalContentLayer.module.scss';
import {useHelpContext} from '@/app/(main)/routes/help/context/HelpContext';

interface IllegalContentLayerProps {
  handleClose?: () => void;
}

const IllegalContentLayer = ({handleClose}: IllegalContentLayerProps) => {
  const {isMobile} = useHelpContext();
  const navigate = useNavigate();

  const handleCloseClick = () => {
    if (handleClose) {
      handleClose();
    } else {
      navigate(-1);
    }
  };

  const content = (
    <div className={styles.listWrapper}>
      <ul>
        <li>
          <div className={styles.descTitle}>불법촬영물</div>
          <div className={styles.descList}>
            <ul>
              <li>
                성적 욕망 또는 수치심을 유발할 수 있는 사람의 신체를
                촬영대상자의 의사에 반하여 촬영한 것
              </li>
              <li>
                성적 욕망 또는 수치심을 유발할 수 있는 사람의 신체를 촬영
                당시에는 촬영대상자의 의사에 반하지 아니한 경우
                <span>
                  (자신의 신체를 직접 촬영한 경우를 포함)에도 사후에
                  촬영대상자의 의사에 반하여 유통된 촬영물
                </span>
              </li>
            </ul>
          </div>
        </li>
        <li>
          <div className={styles.descTitle}>허위영상물</div>
          <div className={styles.descList}>
            <ul>
              <li>
                유통할 목적으로 사람의 얼굴·신체 또는 음성을 대상으로 한
                촬영물·영상물 또는 음성물을 그 대상자의 의사에 반하여 성적 욕망
                또는 수치심을 유발할 수 있는 형태로 편집·합성 또는 가공한 것
              </li>
              <li>
                성적 욕망 또는 수치심을 유발할 수 있는 형태로 편집·합성 또는
                가공할 당시에는 그 대상자의 의사에 반하지 아니한 경우에도 사후에
                그 대상자의 의사에 반하여 유통된 촬영물·영상물 또는 음성물
              </li>
            </ul>
          </div>
        </li>
        <li>
          <div className={styles.descTitle}>
            아동 &middot; 청소년
            <br />
            성착취물
          </div>
          <div className={styles.descList}>
            <ul>
              <li>
                아동 &middot; 청소년 또는 아동·청소년으로 명백하게 인식될 수
                있는 사람이 나 표현물이 등장하여 성교 등 성적 행위 (&quot;아동
                &middot; 청소년의 신체의 전부 또는 일부를 접촉·노출하는 행위로서
                일반인의 성적 수치심이나 혐오감을 일으키는 행위도 포함&quot;)를
                하는 내용이 표현된 것
              </li>
            </ul>
          </div>
        </li>
      </ul>
    </div>
  );

  if (isMobile) {
    return (
      <div className={styles.Container}>
        <SoopSheetTitle
          btnBack
          title='불법촬영물등 유형과 정의 안내'
          onBackClick={handleCloseClick}
          className={styles.SheetTitle}
        />
        {content}
        <div className={styles.BtnArea}>
          <SoopButtonCommon
            onClick={handleCloseClick}
            size={44}
            variant='defaultPrimary'>
            확인
          </SoopButtonCommon>
        </div>
      </div>
    );
  }

  return (
    <SoopLayer onClose={handleCloseClick} size='lg'>
      <SoopLayerHeader align='center'>
        불법촬영물등 유형과 정의 안내
      </SoopLayerHeader>
      <SoopLayerContent>{content}</SoopLayerContent>
    </SoopLayer>
  );
};

export default IllegalContentLayer;
